<div provide-parent-form *ngIf="playout">

	<h3>{{ 'GENERAL' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'OVERRIDE_PLAYER_DIMENSIONS' | translate"
		[helpMessage]="'HELP.VIEWPAGE_OVERRIDE_DIMENSIONS' | translate">
		<bb-check name="playout-viewpage_overrideDimensions" [(ngModel)]="playout.viewpage_overrideDimensions"
			(ngModelChange)="updateViewpagePreview()" [trueValue]="'true'" [falseValue]="'false'"></bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'HIDE_TITLES' | translate">
		<bb-check name="playout-viewpage_hideTitles" [(ngModel)]="playout.viewpage_hideTitles"
			(ngModelChange)="updateViewpagePreview()" [trueValue]="'true'" [falseValue]="'false'"></bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'ALIGNMENT' | translate">
		<bb-position [positions]="[['left', 'center', 'right']]" name="playout-viewpage_alignment"
			[(ngModel)]="playout.viewpage_alignment" (ngModelChange)="updateViewpagePreview()"></bb-position>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'TEXT_COLOR' | translate" class="input-overflow-visible">
		<bb-color-picker-box [(ngModel)]="playout.viewpage_color" [pickerPosition]="'left'" [colorPresets]="usedColors"
			name="playout-viewpage_color" (ngModelChange)="updateViewpagePreview()">
		</bb-color-picker-box>
	</bb-form-element>

	<h3>{{ 'BACKGROUND' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'IMAGE' | translate">
		<bb-logo-selector *ngIf="playout" name="playout-viewpage_backgroundClipId" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="playout.viewpage_backgroundClipId" (entityIdChange)="changedEntityId()"></bb-logo-selector>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'SIZE' | translate"
		[helpMessage]="'HELP.VIEWPAGE_BACKGROUND_IMAGE_SIZING' | translate">
		<bb-select [(ngModel)]="playout.viewpage_backgroundSize" name="playout-viewpage_backgroundSize"
			(ngModelChange)="updateViewpagePreview()">
			<option value="auto">{{ 'ORIGINAL_SIZE' | translate }}</option>
			<option value="cover">{{ 'COVER' | translate }}</option>
			<option value="contain">{{ 'CONTAIN' | translate }}</option>
			<option value="100% 100%">{{ 'STRETCH' | translate }}</option>
		</bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'POSITION' | translate"
		[helpMessage]="'HELP.VIEWPAGE_BACKGROUND_IMAGE_POSITION' | translate">
		<bb-position name="playout-viewpage_backgroundPosition" [(ngModel)]="playout.viewpage_backgroundPosition"
			(onPositionChange)="updateViewpagePreview()"></bb-position>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'BACKGROUND_IMAGE_REPEAT' | translate"
		*ngIf="playout.viewpage_backgroundSize !== '100% 100%' && playout.viewpage_backgroundSize !== 'cover'">
		<bb-select [(ngModel)]="playout.viewpage_backgroundRepeat" name="playout-viewpage_backgroundRepeat"
			(ngModelChange)="updateViewpagePreview()">
			<option value="no-repeat">{{ 'NO_REPEAT' | translate }}</option>
			<option value="repeat">{{ 'REPEAT' | translate }}</option>
			<option value="repeat-x">{{ 'REPEAT_HORIZONTALLY' | translate }}</option>
			<option value="repeat-y">{{ 'REPEAT_VERTICALLY' | translate }}</option>
		</bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'BACKGROUND_COLOR' | translate" class="input-overflow-visible"
		[helpMessage]="'HELP.VIEWPAGE_BACKGROUND_COLOR' | translate">
		<bb-color-picker-box [(ngModel)]="playout.viewpage_backgroundColor" [pickerPosition]="'left'"
			[colorPresets]="usedColors" name="playout-viewpage_backgroundColor"
			(ngModelChange)="updateViewpagePreview()">
		</bb-color-picker-box>
	</bb-form-element>

	<!-- These can be in a loop if they aren't flat values -->
	<h3>{{ 'LOGO' | translate }} 1</h3>

	<bb-form-element [form]="form" [label]="'IMAGE' | translate">
		<bb-logo-selector *ngIf="playout" name="playout-viewpage_logo1ClipId" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="playout.viewpage_logo1ClipId" (entityIdChange)="changedEntityId()"></bb-logo-selector>
	</bb-form-element>

	<bb-form-element *ngIf="playout.viewpage_logo1ClipId" [form]="form" [label]="'POSITION' | translate">
		<bb-position [positions]="viewpageLogoPositions" name="playout-viewpage_logo1Position"
			[(ngModel)]="playout.viewpage_logo1Position" (onPositionChange)="updateViewpagePreview()"></bb-position>
	</bb-form-element>

	<h3>{{ 'LOGO' | translate }} 2</h3>

	<bb-form-element [form]="form" [label]="'IMAGE' | translate">
		<bb-logo-selector *ngIf="playout" name="playout-viewpage_logo2ClipId" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="playout.viewpage_logo2ClipId" (entityIdChange)="changedEntityId()"></bb-logo-selector>
	</bb-form-element>

	<bb-form-element *ngIf="playout.viewpage_logo2ClipId" [form]="form" [label]="'POSITION' | translate">
		<bb-position [positions]="viewpageLogoPositions" name="playout-viewpage_logo2Position"
			[(ngModel)]="playout.viewpage_logo2Position" (onPositionChange)="updateViewpagePreview()"></bb-position>
	</bb-form-element>

	<h3>{{ 'LOGO' | translate }} 3</h3>

	<bb-form-element [form]="form" [label]="'IMAGE' | translate">
		<bb-logo-selector *ngIf="playout" name="playout-viewpage_logo3ClipId" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="playout.viewpage_logo3ClipId" (entityIdChange)="changedEntityId()"></bb-logo-selector>
	</bb-form-element>

	<bb-form-element *ngIf="playout.viewpage_logo3ClipId" [form]="form" [label]="'POSITION' | translate">
		<bb-position [positions]="viewpageLogoPositions" name="playout-viewpage_logo3Position"
			[(ngModel)]="playout.viewpage_logo3Position" (onPositionChange)="updateViewpagePreview()"></bb-position>
	</bb-form-element>

	<h3>{{ 'LOGO' | translate }} 4</h3>

	<bb-form-element [form]="form" [label]="'IMAGE' | translate">
		<bb-logo-selector *ngIf="playout" name="playout-viewpage_logo4ClipId" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="playout.viewpage_logo4ClipId" (entityIdChange)="changedEntityId()"></bb-logo-selector>
	</bb-form-element>

	<bb-form-element *ngIf="playout.viewpage_logo4ClipId" [form]="form" [label]="'POSITION' | translate">
		<bb-position [positions]="viewpageLogoPositions" name="playout-viewpage_logo4Position"
			[(ngModel)]="playout.viewpage_logo4Position" (onPositionChange)="updateViewpagePreview()"></bb-position>
	</bb-form-element>
</div>